import React, { useMemo, useCallback } from "react";
import { connect } from "dva";
import { useLocation } from "dva";
import { ShipmentStatus } from "@/utils/enum";
import { getAllShipments } from "@/services/shipments_new";
import ListView from "@/components/ListView";
import { ListToBeSorted } from "@/components/SortAndFilter";
import useShipmentsListTableColumns from "./utils/useShipmentsListTableColumns";

const DealerShipments = ({ securePassEnabled }) => {
  const { pathname } = useLocation();

  const currentSubPath = useMemo(() => pathname.split("/").pop(), [pathname]);

  const filterStatus = useMemo(() => {
    if (pathname === "/shipments/dealer/posted") {
      return ShipmentStatus.Posted;
    } else if (pathname === "/shipments/dealer/assigned") {
      return ShipmentStatus.Assigned;
    } else if (pathname === "/shipments/dealer/delivered") {
      return ShipmentStatus.Delivered;
    } else if (pathname === "/shipments/dealer/draft") {
      return ShipmentStatus.Draft;
    } else if (pathname === "/shipments/dealer/pending-quotes") {
      return ShipmentStatus.Pending;
    }

    // do not filter
    return null;
  }, [pathname]);

  const columns = useShipmentsListTableColumns({
    filterStatus,
    securePassEnabled,
  });

  const fetchShipmentsList = useCallback(
    async ({ filters }) => {
      if (filterStatus !== null) {
        filters.status = filterStatus;
      }

      try {
        const result = await getAllShipments(filters);

        return {
          data: result?.items ?? [],
          total: result?.totalCount ?? 0,
          success: true,
        };
      } catch (error) {
        return {
          data: [],
          total: 0,
        };
      }
    },
    [filterStatus],
  );

  return (
    <ListView
      filterType={ListToBeSorted.DealerShipments}
      columns={columns}
      baseDetailsUrl={`/shipments/dealer/${currentSubPath}/view`}
      detailsUrlParamName="shipmentId"
      request={fetchShipmentsList}
      tableStyle={{ padding: "0 24px" }}
    />
  );
};

export default connect(({ configs }) => ({
  securePassEnabled: configs.securePass.enabled,
}))(DealerShipments);
